import { STATUS_STYLES } from "../lib/format";
import { cn } from "../lib/utils";

export function StatusBadge({ status, className }) {
  if (!status) return null;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium",
        STATUS_STYLES[status] || "bg-stone-100 text-stone-700 border-stone-200", className)}
    >
      {status.replace(/_/g, " ")}
    </span>
  );
}
